import React from "react";

const EmailIcon: React.FC<{ className?: string; size?: number }> = ({ className = "", size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="19.4444" fill="white" stroke="#EDEBEC" strokeWidth="1.11111" />
      <path
        d="M25.9033 16.8516L21.46 20.4646C20.6205 21.1306 19.4394 21.1306 18.5999 20.4646L14.1191 16.8516"
        stroke="#00A7E4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9089 29C27.9502 29.0084 30 26.5095 30 23.4384V16.57C30 13.4988 27.9502 11 24.9089 11H15.0911C12.0498 11 10 13.4988 10 16.57V23.4384C10 26.5095 12.0498 29.0084 15.0911 29H24.9089Z"
        stroke="#0069AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmailIcon;